import React, { Fragment, useState } from "react";
import MapData from "./MapData";
import { toast } from "react-toastify";
import { ConvertData } from "./ConvertData";

function FancyFont() {
  const [text, setText] = useState("");
  const [answer, setAnswer] = useState("");

  const handleOnErase = () => {
    setAnswer("");
    setText("");
  };

  const handleOnClick = () => {
    let ans = [];
    ConvertData.forEach((item) => {
      let data = text
        .split("")
        .map((l) => {
          return item[l] ? item[l] : l;
        })
        .join("");

      ans.push(data);
    });
    setAnswer(ans);
  };

  const handleOnChange = (event) => {
    setText(event.target.value);
  };

  const clickToCopy = (id) => {
    const dataInput = document.getElementById(id);
    navigator.clipboard.writeText(dataInput?.value);
  };

  return (
    <>
      <div>
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n   .fixed {\n    position: fixed;\n    top:0; left:0;\n    width: 100%; \n    z-index:99; }\n  ",
          }}
        />
        <div className="main-globally-counter-box">
          {text?.length > 0 && (
            <div className="color-picker-icon">
              <i
                className="fa-solid fa-eraser"
                title="Clear"
                onClick={handleOnErase}
              ></i>
            </div>
          )}
          <div className="counter-text-area">
            <textarea
              className="form-control w-100"
              onChange={(e) => handleOnChange(e)}
              name="text"
              value={text}
              placeholder="Type Here & Showdown 30+ Fancy Text"
            />
          </div>
        </div>
        <div className="button lowercase-center-alignment-new">
          <button onClick={handleOnClick}>Show</button>
        </div>
        <div id="result" className="result-text-alignment">
          {answer?.length > 0 &&
            answer?.map((item, indx) => (
              <Fragment key={indx}>
                <p>{MapData[indx].name}</p>
                <div className="input-group mb-3">
                  <input
                    type="text"
                    className="form-control text-2"
                    placeholder={MapData[indx].placeholder}
                    id={indx}
                    readOnly
                    value={item}
                  />
                  <div
                    className="copy-text-alignment"
                    onClick={() => {
                      clickToCopy(indx);
                      toast.success("Copied");
                    }}
                  >
                    <span className="active">Copy</span>
                  </div>
                </div>
              </Fragment>
            ))}
        </div>
      </div>
    </>
  );
}
export default FancyFont;
